import { WritableSignal } from '@angular/core';

export interface IMessage {
    readonly id: string;
    readonly text: WritableSignal<string | null>;
    readonly incomplete: WritableSignal<boolean>;
    readonly audioBytes: WritableSignal<Uint8Array>;
    readonly isResponse: boolean;
    readonly conversationId: string | null;
    readonly attachments: IMessageAttachment[] | null;
}

export interface IMessageResponse {
    conversationId: string;
    messageId: string;
    role: MessageRole;
    content: string;
    createdAtUrc: Date | null;
    attachments: IMessageAttachment[] | null;
    isGenerating: boolean;
}

export interface IMessageAttachment {
    attachmentId: string;
    storagePath: string | null;
    contentType: string | null;
    sizeInBytes: number;
    displayUrl: string;
}

export enum MessageRole {
    Assistant = 0,
    User = 1,
}


